import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import HubHeader from "@/components/HubHeader";
import SessionBlocks, { CommitmentForm } from "@/components/SessionBlocks";
import PLayout from "@/pages/participant/PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { getUi, getTile, getSessionContent } from "@/portal/portal";
import { getPortal } from "@/lib/api";

function PublicShell({ children }) {
  return (
    <div className="rbl">
      <HubHeader />
      <div className="rbl-wrap" style={{ paddingTop: 28, paddingBottom: 50 }}>{children}</div>
    </div>
  );
}

export default function SessionDetail({ inApp = false }) {
  const { number } = useParams();
  const n = parseInt(number, 10);
  const { lang } = useApp();
  const t = getUi(lang);
  const ta = useAppUi(lang);
  const tile = getTile(lang, n);
  const sections = getSessionContent(lang, n);
  const [meta, setMeta] = useState(null);
  const Shell = inApp ? PLayout : PublicShell;
  const base = inApp ? "/app/part1" : "/session";
  const home = inApp ? "/app/part1" : "/";
  const backLabel = inApp ? ta("p1Back") : t("allSessions");

  useEffect(() => {
    window.scrollTo(0, 0);
    getPortal()
      .then((d) => setMeta((d.sessions || []).find((s) => s.number === n) || null))
      .catch(() => setMeta(null));
  }, [n]);

  if (!tile) {
    return (
      <Shell>
        <Link to={home} className="rbl-back">{backLabel}</Link>
        <h1 className="rbl-h1">404</h1>
      </Shell>
    );
  }

  return (
    <Shell>
      <div data-testid={`session-page-${n}`}>
        <Link to={home} className="rbl-back" data-testid="session-back">{backLabel}</Link>
        <div style={{ marginTop: 18 }} className="rbl-sess-eyebrow">
          {inApp && `${ta("navPart1")} · `}{t("sessionKicker")} {String(n).padStart(2, "0")}
        </div>
        <h1 className="rbl-sess-title">{tile.icon} {tile.title}</h1>
        <div className="rbl-sess-sub">{tile.subtitle}</div>

        <SessionBlocks sections={sections} sessionMeta={meta} t={t} />

        {n === 6 && <CommitmentForm t={t} />}

        <div className="rbl-sess-nav">
          {n > 1 ? (
            <Link to={`${base}/${n - 1}`} className="rbl-link" data-testid="session-prev">
              ← {t("sessionWord")} {String(n - 1).padStart(2, "0")}
            </Link>
          ) : <span />}
          {n < 6 ? (
            <Link to={`${base}/${n + 1}`} className="rbl-btn" data-testid="session-next">
              {t("sessionWord")} {String(n + 1).padStart(2, "0")} →
            </Link>
          ) : (
            <Link to={home} className="rbl-btn" data-testid="session-finish">{inApp ? ta("p1Back") : t("backToDashboard")}</Link>
          )}
        </div>
      </div>
    </Shell>
  );
}
